import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackPrechartSentToContextSpec,
  trackPrechartViewedSpec,
  type PrechartSentToContext,
  type PrechartViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const prechartEvents: SnowplowEventMap = {
  [TrackingEventName.PrechartViewed]: (props) =>
    trackPrechartViewedSpec(props as PrechartViewed),
  [TrackingEventName.PrechartSentToContext]: (props) =>
    trackPrechartSentToContextSpec(props as PrechartSentToContext),
};
